import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppAuthGuard } from '../app-auth-guard';
import { RouteGuard } from '../routing-guard';
import { SHAREPOINT_EXPORT_ROLES } from '../user-roles-def/user-roles';
import { ConstructionDocumentsComponent } from './construction-documents/construction-documents.component';
import { SharepointExportComponent } from './sharepoint-export/sharepoint-export.component';

const routes: Routes = [
  {
    path: '?path=:path',
    component: ConstructionDocumentsComponent,
    canActivate: [RouteGuard],
  },
  {
    path: '',
    component: ConstructionDocumentsComponent,
    canActivate: [RouteGuard],
  },
  {
    path: ':ifs',
    component: ConstructionDocumentsComponent,
    canActivate: [RouteGuard],
  },
  {
    path: ':ifs/export',
    component: SharepointExportComponent,
    canActivate: [AppAuthGuard, RouteGuard],
    data: {
      requiredRoles: SHAREPOINT_EXPORT_ROLES,
      rolesCondition: 'or',
      requiredFeatureFlag: 'sharepointExport',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConstructionDocumentsRoutingModule {}
